import type { OriginalStimulusTypes } from "@memorang/types";
import { useTranslation } from "react-i18next";

type CtaInfo = { text: string; icon: string };

export const useCtaInfo = (parentType: OriginalStimulusTypes): CtaInfo => {
	const { t } = useTranslation();
	switch (parentType) {
		case "READING":
			return {
				text: t("session.passageStem.passage"),
				icon: "book-open-page-variant-outline",
			};
		case "LISTENING":
			return {
				text: t("session.passageStem.lecture"),
				icon: "book-open-page-variant-outline",
			};
		case "ACADEMIC_DISCUSSION_STIMULUS":
			return {
				text: t("session.passageStem.professorsQuestion"),
				icon: "book-open-page-variant-outline",
			};
		case "INTEGRATED_WRITING_STIMULUS":
			return {
				text: t("session.passageStem.lecture"),
				icon: "book-open-page-variant-outline",
			};
		case "LS_STIMULUS":
		case "RLS_STIMULUS":
		case "INDEPENDENT_SPEAKING_STIMULUS":
			return { text: t("session.passageStem.listen"), icon: "headphones" };
		default:
			return {
				text: t("session.passageStem.passage"),
				icon: "page-next-outline",
			};
	}
};
